export default "__VITE_ASSET__DsdwQnGV__"